module.exports = __webpack_public_path__ + "static/media/img_snake_head_right.641810dd.svg";